import type { ProductListItemResponse } from '@/typings/responses/ProductListItemResponse';
import type { GetProductsRequest } from '@/typings/requests/GetProductsRequest';
import type { PagedResponse } from '@/typings/responses/PagedResponse';

const rootUrl = '/Umbraco/Api';
const key = 'b5a71f21-a74f-49f0-940d-041674e57e05';

export async function getProducts(request: GetProductsRequest): Promise<PagedResponse<ProductListItemResponse[]>> {
  const requestConfig: RequestInit = {
    headers: {
      'content-type': 'application/json;charset=utf-8',
      'api-key': key
    },
    method: 'post',
    body: JSON.stringify(request)
  };
  const httpRequest = new Request(`${rootUrl}/Products/GetProducts`, requestConfig);
  const response = await fetch(httpRequest);
  if (!response.ok) {
    throw new Error('Erreur');
  }

  return response.json();
}
